import { useState } from 'react'
import { api } from '~/lib/api/client'
import styles from './sign-out-button.module.scss'

type Props = { displayName: string }

export function SignOutButton({ displayName }: Props) {
  const [busy, setBusy] = useState(false)

  async function handleSignOut() {
    if (busy) return
    setBusy(true)
    try {
      await api.signOut()
    } catch {
      // Even if the request errors out, clear the cookie by reload.
    } finally {
      window.location.assign('/sign-in')
    }
  }

  return (
    <button
      type="button"
      className={styles.button}
      onClick={handleSignOut}
      title={`Signed in as ${displayName}. Click to sign out.`}
      aria-label={`Sign out (signed in as ${displayName})`}
      disabled={busy}
    >
      <span className={styles.label}>sign out</span>
    </button>
  )
}
